import { StageContext } from '../../Context';
import { PreprocessStage, StageParameters } from '../../Stage';

interface ComputeLocalMinMaxStageParams extends StageParameters {}

class ComputeLocalMinMax extends PreprocessStage<ComputeLocalMinMaxStageParams> {
    constructor() {
        super({});
    }

    protected override transformContext(input: StageContext): StageContext {
        const localMinMax: [number, number] = [input.sensors[0].getScalarValue(), input.sensors[input.sensors.length - 1].getScalarValue()];
        return { ...input, remappedMinMax: localMinMax };
    }
}

export default ComputeLocalMinMax;
